var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProfileField = function (_a) {
    var label = _a.label, children = _a.children;
    return (_jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-md-3" }, { children: _jsx("label", { children: label }) })), _jsx("div", __assign({ className: "col-md-6" }, { children: children }))] })));
};
export default ProfileField;
